<template>
<vs-popup class="overlay posts-overlay-active-conciergerie" :title="$t(`dash.plan.active_conciergerie_now${activeConciergerie ? '_'+activeConciergerie.network : '' }`)" :active.sync="activeConciergerie">
  <div class="form-connection-conciergerie">
    <p class="subtitle">{{ $t(`dash.bots.connection_subtitle_${page.network}`) }}</p>
    <div v-if="linkedinConnected === 'locked'">
          <p class="connect-warning">{{$t('dash.story.account.locked')}} {{new Date(page.story_config.lock).toLocaleString()}}</p>
    </div>
    <div v-else-if="linkedinConnected === 'connected'">
      <p v-if="!noMatchId" class="connect-success">{{$t('dash.bots.connected_direct')}}</p>
      <div v-else>
        <p class="connect-warning">{{$t('dash.bots.connected_match')}}</p>
      </div>
      <p class="connect-warning" v-if="analysts && analysts.length">{{$t("dash.bots.analysts") + " " + analysts.join(", ")}}</p>
      <p class="connect-warning" v-if="usernamePageDiff">{{$t("dash.bots.username_diff_insta").replace("d'utilisateur", usernamePageDiff) + " " +page.name}}</p>
      <!-- <vs-button v-if="noMatchId" class="modify-btn-linkedin" @click="() => disconnectConciergerie(page.id)">{{$t('dash.posts.disclaimer-post.change-tab.prompt.btn-cancel')}}</vs-button> -->
      <!-- <vs-button v-if="noMatchId" class="disconnect-conciergerie" @click="() => conciergeriePopup=false">{{$t('dash.bots.username_diff_insta_btn1').replace("avec", "")}}</vs-button> -->
      <vs-button v-if="!connectionReturn" class="modify-btn-linkedin" @click="() => linkedinModify=true">Modifier</vs-button>
      <Tooltip v-if="!connectionReturn" :text="$t('dash.pages.disconnect_conciergerie')" position="right">
        <vs-button
          @click="disconnectConciergerie(page.id)" class="disconnect-conciergerie">
          <p>{{$t("dash.header.nav.logout")}}</p>
          <!-- <p>{{$t("dash.pages.disconnect_conciergerie")}}</p> -->
        </vs-button>
        <span>&nbsp;</span>
      </Tooltip>
      <vs-button v-else-if="!noMatchId" class="modify-btn-linkedin" @click="closePopup">OK</vs-button>
      <vs-button v-if="usernamePageDiff && !noMatchId"
              @click="disconnectConciergerie(page.id)" class="disconnect-conciergerie">
              <p>{{$t("dash.header.nav.logout")}}</p>
              <!-- <p>{{$t("dash.pages.disconnect_conciergerie")}}</p> -->
      </vs-button>
    </div>
    <div v-else-if="noMatchId">
          <p class="connect-warning">{{$t('dash.bots.connected_match')}}</p>
          <vs-button class="modify-btn-linkedin" @click="() => noMatchId=false">OK</vs-button>
    </div>
    <div v-else class="conciergerie-instruction">
      <h3 v-if="['linkedin', 'tiktok', 'facebook', 'twitter'].includes(page.network)" class="conciergerie-instruction-title">{{page.network === 'tiktok' ? $t('dash.bots.connection_method_tiktok') : page.network === 'facebook' ? $t('dash.bots.connection_method_facebook') : page.network === 'twitter' ? $t('dash.bots.connection_method_twitter') : $t('dash.bots.connection_method_1')}}</h3>
          <div v-if="['linkedin', 'tiktok', 'facebook', 'twitter'].includes(page.network)" class="conciergerie-instruction-method method-1">
            <vs-button v-if="!extension" @click="useExtension">{{$t(`dash.bots.connection_open_extension`)}}</vs-button>
            <p v-if="!extension">{{$t('dash.bots.extension_explication_1')}}</p>
            <p  v-if="!extension" v-html="$t(`dash.bots.extension_explication_2_${page.network}`)"></p>
            <p v-else v-html="$t(`dash.bots.extension_explication_3_${page.network}`)"></p>
          </div>
          <h3 v-if="['linkedin'].includes(page.network)" class="conciergerie-instruction-title">{{$t('dash.bots.connection_method_2')}}</h3>
          <div v-if="['linkedin', 'instagram'].includes(page.network)" class="conciergerie-instruction-method method-2">
            <vs-input :label="$t(`dash.bots.connection_email${page.network === 'instagram' ? '_username' : ''}`)" :placeholder="$t(`dash.bots.connection_email${page.network === 'instagram' ? '_username' : ''}`)" v-model="linkedinUsername" @keypress.enter.prevent="connectLinkedin" @submit.prevent="connectLinkedin"/>
            <vs-input :type="showPass ? 'text' : 'password'" :label="$t('dash.bots.connection_password')" :placeholder="$t('dash.bots.connection_password')" v-model="linkedinPassword" @submit.prevent="connectLinkedin" @keypress.enter.prevent="connectLinkedin"/>
            <vs-button class="btn-eye" type="fill" 
              @click="showPass = !showPass"
              :icon="showPass ? 'visibility_off' : 'visibility'"
            ></vs-button>
      </div>
      <template v-if="['linkedin', 'instagram'].includes(page.network)">
        <!-- <p class="warning-two-auth" v-if="['linkedin', 'instagram'].includes(page.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
        <p class="warning-two-auth" v-if="['instagram'].includes(page.network)">{{ $t('dash.bots.warning_two_auth_insta')}}</p> -->
        <p class="warning-two-auth" v-if="['linkedin'].includes(page.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
        <!-- <p class="warning-two-auth" v-if="['instagram'].includes(page.network)">{{ $t('dash.bots.warning_no_two_auth')}}</p> -->
        <div class="username-conciergerie-diff" v-if="page.network === 'instagram' && instagramPagesUsernames.map(e => e.username).includes(linkedinUsername)">
          <p >{{$t("dash.bots.username_used_insta") + instagramPagesUsernames.find(e => e.username === linkedinUsername).name}}</p>
          <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="() => linkedinUsername =''" color="primary" type="filled">{{$t("dash.button.cancel")}}</vs-button>
          ou
          <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
        </div>
        <div class="username-conciergerie-diff" v-else-if="page && page.id !== 'createPage' && page.network === 'instagram' && linkedinUsername && page.name.trim() !== linkedinUsername.trim()">
          <p >{{$t("dash.bots.username_diff_insta")}}</p>
          <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
          ou
          <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="(e) => connectLinkedin(e, true)" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn2") + page.name}}</vs-button>
        </div>
        <vs-button v-else id="linkedin-direct-loading" class="vs-con-loading__container" @click="connectLinkedin" color="primary" type="filled">{{ $t('dash.bots.connect_direct') }}</vs-button>
      </template>
    </div>
    <vs-popup title="Authentification à deux facteurs" :active.sync="twoFactorPopup" class="two-factor-authentification">
      <TwoFactorAuthenticationPopup :createPage="page.id === 'createPage'" :pageid="twoFactorPopup" :pages="pages" @closePopup="closePopup" v-on:getPagesEvent="getPagesEvent"/>
    </vs-popup>
    <component-loader :progress="90" :unlimitedProgress="true" v-if="showLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader>
  </div>
</vs-popup>
</template>

<script>

import User from '../../mixins/User'
import Pages from '../../mixins/Pages'
import Bots from '../../mixins/Bots'
import Notif from '../../mixins/Notif'
import TwoFactorAuthenticationPopup from '../TwoFactorAuthenticationPopup.vue'
import componentLoader from './Loader.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-conciergerie-form',
  
  mixins: [Bots, Pages, User, Notif],

  props: {
    page: Object,
    activeConciergerie: Object|Boolean
  },

  components: {
    TwoFactorAuthenticationPopup,
    componentLoader,
    Tooltip
  },

  data() {
    return {
      connectionReturn: false,
      showPass: false,
      linkedinModify: false,
      linkedinUsername: '',
      linkedinPassword: '',
      twoFactorPopup: false,
      pages: [],
      showLoader: false,
      extension: false,
      instagramPagesUsernames: [],
      usernamePageDiff: null,
      noMatchId: false,
      analysts: [],
    }
  },

  computed: {
    linkedinConnected() {
      if (this.page.story_config && this.page.story_config.created && this.page.story_config.lock && this.page.story_config.lock > Date.now() && (((this.page.network === 'instagram')))) {
        return 'locked';
      }
      if (this.linkedinModify) {
        return 'modify';
      }
      if (this.page.story_config && this.page.story_config.created) {
        return 'connected';
      } else if (this.page.story_config && ((this.page.network === 'linkedin' && this.page.story_config.challenge_informations) || (this.page.network === 'instagram' && this.page.story_config.two_factor))) {
        return 'challenge';
      } else {
        return 'none';
      }
    },
  },

  mounted() {
    // console.log('mount')
    this.checkLockDirectApi(this.page);
    this.extensionInstalled()
    this.getInstagramPagesUsername()

  },

  watch: {
    activeConciergerie: function(newVal) {
      if (!newVal) {
        this.closePopup();
      }
    }
  },

  methods: {

    async getInstagramPagesUsername() {
      this.getPages().then(res => {
        let {pages} = res.body;
        this.instagramPagesUsernames = pages.filter(e => e.network === 'instagram' && this.page && e.id !== this.page.id).map(e => {return {username: e.instagram_username, name: e.name}});
      })
    },

    async extensionInstalled() {
      return new Promise((resolve, reject) => {
        let img = new Image();
        const extensionId = "lmojmckfefcipoompcaedhnbbkeceohm"
        img.src = "chrome-extension://" + extensionId + "/icons/icon_16.png";
        img.onload = () => {
          this.extension = true;
          resolve(true);
        };
        img.onerror = () => {
          this.extension = false;
          resolve(false);
        };
      });
    },

    useExtension() {
      if (typeof chrome !== 'undefined') {
        this.extensionInstalled().then(installed => {
          if (installed) {
            const targetUrl = this.page.network === 'tiktok' ? 'https://www.tiktok.com/' : this.page.network === 'facebook' ? 'https://www.facebook.com/' : this.page.network === 'twitter' ? 'https://x.com/' : 'https://linkedin.com/';
            window.open(targetUrl, '_blank').focus();
          } else {
            console.log('redirect to download link');
            window.open("https://chrome.google.com/webstore/detail/mashup-web/lmojmckfefcipoompcaedhnbbkeceohm", '_blank').focus();
          }
          this.closePopup()
        })
      } else {
        this.$vs.notify({
          title: "Navigateur incompatible",
          text: this.$t("dash.bots.extension_chrome_only"),
          color:'warning',
          time: 10000
        })
      }
    },
   
    async connectLinkedin(e, replaceUsername = false) {
      // console.log(this.linkedinUsername);
      // console.log(this.linkedinPassword);
      // console.log(this.page.id);
      if (replaceUsername) {
        this.linkedinUsername = this.page.name;
      }
      
      this.linkedinUsername = this.linkedinUsername.trim();
      this.linkedinPassword = this.linkedinPassword.trim();
      let body = {
        pageId: this.page.id,
        usernameAccount: this.linkedinUsername,
        passwordAccount: this.linkedinPassword,
      }
      this.showLoader = true
      this.connectLinkedinDirect(body).then(async response =>  {
        // console.log(response);
        this.showLoader = false
        if (response.ok && response.body && response.body.connected) {
          this.usernamePageDiff = (this.page && this.page.id !== 'createPage' && response.body.username !== this.page.name) ? response.body.username : null;
          if (response.body.story_config) {
            this.$set(this.page, 'story_config', response.body.story_config);
          }
          if (response.body.id) {
            this.$set(this.page, 'id', response.body.id);
          }
          await this.fetchPages();
          this.connectionReturn = true;
          this.linkedinModify = false;      
          this.getPagesEvent()
          this.noMatchId = !response.body.match;
          if (response.body.analysts) {
            this.analysts = response.body.analysts;
          } else {
            this.analysts = [];
          }
          // this
          // this.submitAfterConnection(); 
        } else if (response.ok && response.body && response.body.twoAuth) {
          if (response.body.story_config) {
            this.$set(this.page, 'story_config', response.body.story_config);
            this.getPagesEvent();
          }
          this.fetchPages();
          this.twoFactorPopup = response.body.id || this.page.id
        } else if (response.ok && response.body && response.body.challengeInstagram) {
          // this.$vs.notify({
          if (response.body.id) {
            this.page.id = response.body.id;
          }
          this.fetchPages();
          this.twoFactorPopup = this.page.id;
          // this.notify({
          //   title:'Erreur de connexion',
          //   text: this.$t('dash.bots.two_auth_failed'),
          //   color: 'primary',
          //   time: 10000,
          //   id: this.page.id
          // }, {
          //   component: "Conciergerie",
          //   action: "connectLinkedinDirect",
          //   params: {
          //     pageId: this.page.id,
          //     usernameAccount: this.linkedinUsername,
          //     passwordAccount: 'XXXX',
          //     responseBody: response.body
          //   }
          // });
        } else if (response.ok && response.body && response.body.badPassword) {
          // this.$vs.notify({
          if (response.body.id) {
            this.page.id = response.body.id;
          }
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.bad_password'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        } else if (response.ok && response.body && response.body.captcha) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.captcha'),
              color: 'primary',
              time: 10000,
              id: 'repeat'
            }, {
              component: "Conciergerie",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          }  else if (response.ok && response.body && response.body.invalidUser) {
          // this.$vs.notify({
          this.notify({
            title:this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.invalid_user'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        } else if (response.ok && response.body && response.body.csrfToken) {
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.csrf_token'),
            color: 'primary',
            time: 8000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        }
        else if (response.ok && response.body && response.body.notImplementedChall) {
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: this.$t('dash.bots.not_implemented'),
            color: 'primary',
            time: 10000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              responseBody: response.body
            }
          });
        }
        else if (!response.ok) {
          if (response.body.id) {
            this.page.id = response.body.id;
          }
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.connection_error_title'),
            text: response.body.msg || response.bodyText,
            color: 'primary',
            time: 5000,
            id: 'repeat'
          }, {
            component: "Conciergerie",
            action: "connectLinkedinDirect",
            params: {
              pageId: this.page.id,
              usernameAccount: this.linkedinUsername,
              passwordAccount: 'XXXX',
              response: response
            }
          });
        }
      });
    },

    async disconnectConciergerie(idPage) {
      // console.log(idPage);
      await this.disconnectDirectApi(idPage);
      this.getPagesEvent()
      // this.gridData = this.gridData.map(e => {
      //   if (e.pages.id === idPage) {
      //     e.pages.story_config = null;
      //     e.bots[0].page.story_config = null;
      //   }
      //   return e;
      // });
      // await this.fetchPages();
      // await this.fetchBots();
      // this.$emit('update-multipletable', this.gridData)
      // this.$forceUpdate();
    },

    async closePopup() {
      this.$emit('closeActiveConciergerie')
      // await this.fetchPages(); 
      // this.submitAfterConnection();
    },

    getPagesEvent() {
      this.$emit('getPagesEvent')
    },

    async fetchPages() {
        return this.getPages()
                   .then(res => {
                    //  console.log(res.body)
                     const { pages } = res.body
                     // TODO remove this once it wont be used
                     localStorage.setItem('pages', JSON.stringify(pages))
                     this.pages = pages
                       .sort((page1, page2) => {
                         const [d1, d2] = [page1, page2].map(x => new Date(x.updated_at))
                         if (d1 < d2) return -1
                         if (d1 > d2) return +1
                         return 0
                       })
                   })
      },
  }
}
</script>
